import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Snackbar from '@mui/material/Snackbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import getLogger from '../../common/Logger';

import useStyles from './SnackBar.jss';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

function KarnakSnackBar({
  anchorOrigin = { vertical: 'bottom', horizontal: 'right' },
  duration = 5000,
  message = '',
  open = false,
  onClose = () => getLogger().info('close snackbar called!'),
  variant = 'info',
  ...other
}) {
  const classes = useStyles();

  const Icon = variantIcon[variant];
  const messageComponent = (
    <span id="client-snackbar" className={classes.message}>
      <Icon className={clsx(classes.icon, classes.iconVariant)} />
      {message}
    </span>
  );

  let autoHideDuration = duration;

  if (!autoHideDuration && variant === 'success') {
    autoHideDuration = 3000;
  }

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      {...other}
    >
      <SnackbarContent
        className={clsx(classes[variant])}
        aria-describedby="client-snackbar"
        message={messageComponent}
        action={[
          <IconButton
            onClick={onClose}
            key="close"
            aria-label="close"
            color="inherit"
          >
            <CloseIcon className={classes.icon} />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
}

KarnakSnackBar.propTypes = {
  anchorOrigin: PropTypes.object,
  duration: PropTypes.number,
  message: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
};

export default KarnakSnackBar;
